module.exports = __webpack_public_path__ + "static/video3-399bc3044ead91c3aa7c48fd8eaa18cc.png";